/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import CafeteriaTable from "./SubComponents/CafeteriaTable";
import CafeteriasApp from "./Functionality/CafeteriasApp";
import DeleteModal from "../../../Modals/DeleteModal";
import CommonFoodieMainApp from "./Functionality/CommonFoodieMainApp";
import {TABS_FOODIE} from "../Model/Models";

const Cafeterias = ({
    bodyForExport,
    setBodyForExport,
    modified,
    setModified,
    option
}) => {
    const {
        t,
        contractorId,
        supplierId,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
    } = CafeteriasApp();

    const {
        deleteModalShow,
        handleDeleteModalClose,
        handleDeleteSelected,
        handleDeleteItem
    } = CommonFoodieMainApp({
        setIsAllChecked,
        tabIndex: TABS_FOODIE.CAFETERIAS.INDEX,
        tableName: option,
        selectedList,
        setSelectedList,
        setModified
    });

    return (
        <>
            <CafeteriaTable
                contractorId={contractorId}
                supplierId={supplierId}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                search={search}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                modified={modified}
                setModified={setModified}
                bodyForExport={bodyForExport}
                setBodyForExport={setBodyForExport}
                onDeleteItem={handleDeleteItem}
                option={option}
            />

            { deleteModalShow &&
                <DeleteModal
                    show={deleteModalShow}
                    onHide={() => handleDeleteModalClose()}
                    onClickFn={() => {
                        handleDeleteSelected()
                    }}
                    data={selectedList}
                    title_modal={t('delete_cafeterias')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('cafeterias')}
                    buttonCancelText={'cancel'}
                />
            }
        </>
    );
};
export default Cafeterias;
